(function (root, factory) {
  var Siema = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = Siema;
  if (root) root.Siema = Siema;
})(typeof window !== 'undefined' ? window : null, function (root) {
  // Siema 轮播引擎：从旧 index.js 独立，保留循环、触摸/鼠标拖拽与过渡动画。
  function Siema(options) {
    var self = this;
    this.config = Siema.mergeSettings(options || {});
    this.selector = typeof this.config.selector === 'string'
      ? root.document.querySelector(this.config.selector) : this.config.selector;
    if (!this.selector) throw new Error('Siema selector is invalid');
    this.resolveSlidesNumber();
    this.selectorWidth = this.selector.offsetWidth;
    this.innerElements = Array.prototype.slice.call(this.selector.children);
    this.currentSlide = this.config.loop
      ? this.config.startIndex % this.innerElements.length
      : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage));
    this.transformProperty = Siema.webkitOrNot(root);
    ['resizeHandler', 'touchstartHandler', 'touchendHandler', 'touchmoveHandler',
      'mousedownHandler', 'mouseupHandler', 'mouseleaveHandler', 'mousemoveHandler', 'clickHandler']
      .forEach(function (method) { self[method] = self[method].bind(self); });
    this.init();
  }

  Siema.mergeSettings = function (options) {
    var settings = {
      selector: '.siema', duration: 200, easing: 'ease-out', perPage: 1, startIndex: 0,
      draggable: true, multipleDrag: false, threshold: 20, loop: false, rtl: false,
      onInit: function () {}, onChange: function () {}
    };
    Object.keys(options || {}).forEach(function (key) { settings[key] = options[key]; });
    return settings;
  };

  Siema.webkitOrNot = function (windowRoot) {
    if (!windowRoot || !windowRoot.document) return 'transform';
    return typeof windowRoot.document.documentElement.style.transform === 'string'
      ? 'transform' : 'WebkitTransform';
  };

  Siema.prototype.init = function () {
    this.attachEvents();
    this.selector.style.overflow = 'hidden';
    this.selector.style.direction = this.config.rtl ? 'rtl' : 'ltr';
    this.buildSliderFrame();
    this.config.onInit.call(this);
  };

  Siema.prototype.attachEvents = function () {
    root.addEventListener('resize', this.resizeHandler);
    if (!this.config.draggable) return;
    this.pointerDown = false;
    this.drag = { startX: 0, endX: 0, startY: 0, letItGo: null, preventClick: false };
    this.selector.addEventListener('touchstart', this.touchstartHandler);
    this.selector.addEventListener('touchend', this.touchendHandler);
    this.selector.addEventListener('touchmove', this.touchmoveHandler, { passive: false });
    this.selector.addEventListener('mousedown', this.mousedownHandler);
    this.selector.addEventListener('mouseup', this.mouseupHandler);
    this.selector.addEventListener('mouseleave', this.mouseleaveHandler);
    this.selector.addEventListener('mousemove', this.mousemoveHandler);
    this.selector.addEventListener('click', this.clickHandler);
  };

  Siema.prototype.resolveSlidesNumber = function () {
    if (typeof this.config.perPage === 'number') return void (this.perPage = this.config.perPage);
    this.perPage = 1;
    Object.keys(this.config.perPage).forEach(function (breakpoint) {
      if (root.innerWidth >= Number(breakpoint)) this.perPage = this.config.perPage[breakpoint];
    }, this);
  };

  Siema.prototype.buildSliderFrameItem = function (element) {
    var item = root.document.createElement('div');
    item.style.cssFloat = this.config.rtl ? 'right' : 'left';
    item.style.float = this.config.rtl ? 'right' : 'left';
    item.style.width = (this.config.loop
      ? 100 / (this.innerElements.length + (2 * this.perPage))
      : 100 / this.innerElements.length) + '%';
    item.appendChild(element);
    return item;
  };

  Siema.prototype.buildSliderFrame = function () {
    var frameLength = this.config.loop
      ? this.innerElements.length + (2 * this.perPage) : this.innerElements.length;
    var fragment = root.document.createDocumentFragment();
    var index;
    this.sliderFrame = root.document.createElement('div');
    this.sliderFrame.style.width = ((this.selectorWidth / this.perPage) * frameLength) + 'px';
    this.enableTransition();
    if (this.config.draggable) this.selector.style.cursor = '-webkit-grab';
    if (this.config.loop) {
      for (index = this.innerElements.length - this.perPage; index < this.innerElements.length; index += 1) {
        fragment.appendChild(this.buildSliderFrameItem(this.innerElements[index].cloneNode(true)));
      }
    }
    for (index = 0; index < this.innerElements.length; index += 1) {
      fragment.appendChild(this.buildSliderFrameItem(this.innerElements[index]));
    }
    if (this.config.loop) {
      for (index = 0; index < this.perPage; index += 1) {
        fragment.appendChild(this.buildSliderFrameItem(this.innerElements[index].cloneNode(true)));
      }
    }
    this.sliderFrame.appendChild(fragment);
    this.selector.innerHTML = '';
    this.selector.appendChild(this.sliderFrame);
    this.slideToCurrent();
  };

  Siema.prototype.enableTransition = function () {
    if (!this.sliderFrame) return;
    var value = 'all ' + this.config.duration + 'ms ' + this.config.easing;
    this.sliderFrame.style.webkitTransition = value;
    this.sliderFrame.style.transition = value;
  };

  Siema.prototype.disableTransition = function () {
    var value = 'all 0ms ' + this.config.easing;
    this.sliderFrame.style.webkitTransition = value;
    this.sliderFrame.style.transition = value;
  };

  Siema.prototype.slideToCurrent = function (afterLoopJump) {
    var self = this;
    var index = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
    var offset = (this.config.rtl ? 1 : -1) * index * (this.selectorWidth / this.perPage);
    function apply() {
      self.sliderFrame.style[self.transformProperty] = 'translate3d(' + offset + 'px, 0, 0)';
    }
    if (afterLoopJump && root.requestAnimationFrame) {
      root.requestAnimationFrame(function () {
        root.requestAnimationFrame(function () { self.enableTransition(); apply(); });
      });
    } else apply();
  };

  Siema.prototype.prev = function (step) {
    step = step || 1;
    if (this.innerElements.length <= this.perPage) return;
    var oldIndex = this.currentSlide;
    if (this.config.loop && this.currentSlide - step < 0) {
      this.disableTransition();
      this.currentSlide += this.innerElements.length;
      this.slideToCurrent();
      this.currentSlide -= step;
      this.slideToCurrent(true);
    } else {
      this.currentSlide = this.config.loop ? this.currentSlide - step : Math.max(this.currentSlide - step, 0);
      this.slideToCurrent();
    }
    if (oldIndex !== this.currentSlide) this.config.onChange.call(this);
  };

  Siema.prototype.next = function (step) {
    step = step || 1;
    if (this.innerElements.length <= this.perPage) return;
    var oldIndex = this.currentSlide;
    if (this.config.loop && this.currentSlide + step > this.innerElements.length - this.perPage) {
      this.disableTransition();
      this.currentSlide -= this.innerElements.length;
      this.slideToCurrent();
      this.currentSlide += step;
      this.slideToCurrent(true);
    } else {
      this.currentSlide = this.config.loop ? this.currentSlide + step
        : Math.min(this.currentSlide + step, this.innerElements.length - this.perPage);
      this.slideToCurrent();
    }
    if (oldIndex !== this.currentSlide) this.config.onChange.call(this);
  };

  Siema.prototype.goTo = function (index) {
    if (this.innerElements.length <= this.perPage) return;
    var oldIndex = this.currentSlide;
    this.currentSlide = this.config.loop ? Number(index) % this.innerElements.length
      : Math.min(Math.max(Number(index), 0), this.innerElements.length - this.perPage);
    if (oldIndex !== this.currentSlide) {
      this.slideToCurrent();
      this.config.onChange.call(this);
    }
  };

  Siema.prototype.updateAfterDrag = function () {
    var movement = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX);
    var distance = Math.abs(movement);
    var step = this.config.multipleDrag ? Math.ceil(distance / (this.selectorWidth / this.perPage)) : 1;
    if (movement > 0 && distance > this.config.threshold) this.prev(step);
    if (movement < 0 && distance > this.config.threshold) this.next(step);
    this.slideToCurrent();
  };

  Siema.prototype.dragTo = function (pageX) {
    this.drag.endX = pageX;
    this.disableTransition();
    var index = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
    var base = index * (this.selectorWidth / this.perPage);
    var movement = this.drag.endX - this.drag.startX;
    var offset = this.config.rtl ? base + movement : base - movement;
    this.sliderFrame.style[this.transformProperty] =
      'translate3d(' + ((this.config.rtl ? 1 : -1) * offset) + 'px, 0, 0)';
  };

  Siema.prototype.clearDrag = function () {
    this.drag = { startX: 0, endX: 0, startY: 0, letItGo: null, preventClick: this.drag.preventClick };
  };

  Siema.prototype.touchstartHandler = function (event) {
    if (['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(event.target.nodeName) !== -1) return;
    event.stopPropagation(); this.pointerDown = true;
    this.drag.startX = event.touches[0].pageX; this.drag.startY = event.touches[0].pageY;
  };
  Siema.prototype.touchmoveHandler = function (event) {
    event.stopPropagation();
    if (this.drag.letItGo === null) {
      this.drag.letItGo = Math.abs(this.drag.startY - event.touches[0].pageY)
        < Math.abs(this.drag.startX - event.touches[0].pageX);
    }
    if (this.pointerDown && this.drag.letItGo) { event.preventDefault(); this.dragTo(event.touches[0].pageX); }
  };
  Siema.prototype.touchendHandler = function (event) {
    event.stopPropagation(); this.pointerDown = false; this.enableTransition();
    if (this.drag.endX) this.updateAfterDrag(); this.clearDrag();
  };
  Siema.prototype.mousedownHandler = function (event) {
    if (['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(event.target.nodeName) !== -1) return;
    event.preventDefault(); event.stopPropagation(); this.pointerDown = true; this.drag.startX = event.pageX;
  };
  Siema.prototype.mousemoveHandler = function (event) {
    event.preventDefault(); if (!this.pointerDown) return;
    if (event.target.nodeName === 'A') this.drag.preventClick = true;
    this.selector.style.cursor = '-webkit-grabbing'; this.dragTo(event.pageX);
  };
  Siema.prototype.mouseupHandler = function (event) {
    event.stopPropagation(); this.pointerDown = false; this.selector.style.cursor = '-webkit-grab';
    this.enableTransition(); if (this.drag.endX) this.updateAfterDrag(); this.clearDrag();
  };
  Siema.prototype.mouseleaveHandler = function (event) {
    if (!this.pointerDown) return;
    this.pointerDown = false; this.selector.style.cursor = '-webkit-grab'; this.drag.endX = event.pageX;
    this.drag.preventClick = false; this.enableTransition(); this.updateAfterDrag(); this.clearDrag();
  };
  Siema.prototype.clickHandler = function (event) {
    if (this.drag.preventClick) event.preventDefault(); this.drag.preventClick = false;
  };
  Siema.prototype.resizeHandler = function () {
    this.resolveSlidesNumber();
    if (this.currentSlide + this.perPage > this.innerElements.length) {
      this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage;
    }
    this.selectorWidth = this.selector.offsetWidth; this.buildSliderFrame();
  };

  return Siema;
});
